const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the assignment templates search component
 */
app.directive('assignmentTemplatesSearch', ['AssignmentTemplates', function (AssignmentTemplates) {
  return {
    restrict: 'E',
    scope: {
      onChange: '&',
      selectionLimit: '@'
    },
    replace: true,
    template: require('../../../templates/directives/assignments/assignment-templates-search.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      
      self.queries = [];

      // ------------- start ngTag triggered actions ------------
      self.tagInput = {
        addingTag: function ($tag) {
          if (!$tag._id) {
            $tag.text = $tag.title;
            $tag.type = 'text';
          }
          if ($scope.selectionLimit) {
            if (self.queries.length && self.queries.length >= $scope.selectionLimit) {
              self.queries.splice(0, 1);
            }
          }
          return true;
        },
        addedTag: function () {
          self.updateQuery();
        },
        removedTag: function () {
          self.updateQuery();
        },
        clear: function (outside) {
          self.queries.splice(0);
          if (!outside) {
            self.updateQuery();
          }
        }
      };
      // ------------- End ngTag triggered actions ------------

      self.updateQuery = function() {
        $scope.onChange({items: self.queries});
      };

      self.getOptions = async function(input) {
        return await AssignmentTemplates.find({query: {term: input}}).$promise;
      };
    }],

    controllerAs: 'search'
  };
}]);